import { WIDGET_ICON_OPTIONS } from 'common/constants';

export default (img) => {
    const isIcon = WIDGET_ICON_OPTIONS.find(icon => icon.url === img);
    if (isIcon) return true;
    return false;
  };